webpackJsonp([94],{

/***/ 1192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isSwitched: false,
            isSwitchedCustom: 'Yes'
        };
    }
});

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "field"
  }, [_c('b-switch', [_vm._v("Default")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isSwitched),
      callback: function($$v) {
        _vm.isSwitched = $$v
      },
      expression: "isSwitched"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.isSwitched) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "true-value": "Yes",
      "false-value": "No"
    },
    model: {
      value: (_vm.isSwitchedCustom),
      callback: function($$v) {
        _vm.isSwitchedCustom = $$v
      },
      expression: "isSwitchedCustom"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.isSwitchedCustom) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1192),
  /* template */
  __webpack_require__(1193),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/94.64408a544a06778ecab0.js